import { useSelector } from 'react-redux'
import { ApplicationState } from 'redux/Stores/types'
import { TestEnvironmentStore } from 'redux/reducers/TestEnvironment'

export const useTestEnvironment = (): TestEnvironmentStore =>
  useSelector((state: ApplicationState) => state.TestEnvironmentStore)
